import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { RequireAdmin } from '@/components/RequireAdmin';
import { AdminLayout } from '@/components/AdminLayout';
import { LoginPage } from '@/pages/LoginPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { WorkbookEditorPage } from '@/pages/WorkbookEditorPage';
import { WorkbookPreviewPage } from '@/pages/WorkbookPreviewPage';
import { OrdersPage } from '@/pages/OrdersPage';
import { SubscribersPage } from '@/pages/SubscribersPage';
import { StudioPage } from '@/pages/StudioPage';
import { AuditLogPage } from '@/pages/AuditLogPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import { DeliveriesPage } from '@/pages/DeliveriesPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { ProductsPage } from '@/pages/ProductsPage';
import { CommunityPhotosPage } from '@/pages/CommunityPhotosPage';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route element={<RequireAdmin />}>
          <Route element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="deliveries" element={<DeliveriesPage />} />
            <Route path="workbook/:id" element={<WorkbookEditorPage />} />
            <Route path="workbook/:id/preview" element={<WorkbookPreviewPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="subscribers" element={<SubscribersPage />} />
            <Route path="studio" element={<StudioPage />} />
            <Route path="audit" element={<AuditLogPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="community" element={<CommunityPhotosPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}
